const validate = (values = {}) => {
	const errors = {};

	if (!values.permission) errors.permission = "Selecione uma permissão";

	return errors;
};

export default validate;
